import { IReservationObjectData } from 'modules/accommodations/features/reservations/models';

export const indexOfElement = (
  reservationObjectData: IReservationObjectData[],
  propertyId: string,
) => {
  return reservationObjectData?.findIndex(
    (object: IReservationObjectData) => object?.propertyId === propertyId,
  );
};
